export default {"src":"/pro/_next/static/media/vlp.8e49e6df.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};